export default [
  {
    id: '0e0b55f9-39b9-48b9-9c62-fe59fff3624a',
    path: 'home',
    name: 'home',
    meta: { title: '首页' },
    component: () => {
      return import('../views/home/index')
    },
  },
]
